import { Registry, initRegistry } from './utils'
import * as RegistryWidgets from '@widgets/article'

const registry: Registry = {}

initRegistry(registry, RegistryWidgets)

export default registry
